import axiosInstance from '@/api/axiosInstance';
import {
  MemberTypeSearchParams,
  MemberTypeListResponse,
  MemberTypeListApiResponse,
  MemberTypeDetailApiResponse,
  MemberTypeRecord,
  MemberTypeFormData,
  PrivilegeOption,
} from './types';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 获取会员类型列表
 */
export const getMemberTypeList = async (
  params: MemberTypeSearchParams
): Promise<MemberTypeListResponse> => {
  const response = await axiosInstance.get<MemberTypeListApiResponse>(
    `${baseUrl}/member/v1/pageList`,
    {
      params: {
        currentPage: params.currentPage || 1,
        pageSize: params.pageSize || 10,
      },
    }
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取会员类型列表失败');
};

/**
 * 获取会员类型详情
 */
export const getMemberTypeDetail = async (id: number): Promise<MemberTypeRecord> => {
  const response = await axiosInstance.get<MemberTypeDetailApiResponse>(
    `${baseUrl}/member/v1/detail`,
    {
      params: {
        id,
      },
    }
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取会员类型详情失败');
};

/**
 * 创建会员类型
 */
export const createMemberType = async (
  data: MemberTypeFormData
): Promise<{ success: boolean; message: string }> => {
  const response = await axiosInstance.post<{
    status: number;
    success: boolean;
    message: string;
  }>(`${baseUrl}/member/v1/add`, data);

  if (response.data.success) {
    return { success: true, message: '创建成功' };
  }

  throw new Error(response.data.message || '创建失败');
};

/**
 * 更新会员类型
 */
export const updateMemberType = async (
  id: number,
  data: MemberTypeFormData
): Promise<{ success: boolean; message: string }> => {
  const response = await axiosInstance.post<{
    status: number;
    success: boolean;
    message: string;
  }>(`${baseUrl}/member/v1/edit`, { ...data, id });

  if (response.data.success) {
    return { success: true, message: '更新成功' };
  }

  throw new Error(response.data.message || '更新失败');
};

/**
 * 获取权益列表（用于下拉选择）
 */
export const getPrivilegeList = async (): Promise<PrivilegeOption[]> => {
  const response = await axiosInstance.get<{
    status: number;
    success: boolean;
    message: string;
    data: PrivilegeOption[];
  }>(`${baseUrl}/memberPrivilege/v1/list`);

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || '获取权益列表失败');
};

